import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Orgsetting } from '../model/orgsetting';

@Injectable({
  providedIn: 'root'
})
export class OrgsettingsService {

  constructor(private http: HttpClient) { }
    //get the org settings from the server
   // GET	    /organization/{organizationId}/settings	
    getOrgSettings(){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
      return this.http.get<Orgsetting>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/settings',httpOptions);
    }
    //update the org settings
    // PUT	    /organization/{organizationId}/settings
    updateOrgSettings(data:Orgsetting){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
     //console.log('data in service',data);
      return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/settings',JSON.stringify(data) ,httpOptions);
    }
}
